import ContentPage from "../templates/ContentPage";
import { PAGES } from "../content/pagesContent";
import { useI18n } from "../i18n";

const usePage = (key) => {
  const { lang } = useI18n();
  return (PAGES[lang] || PAGES.en)[key];
};

export function PrivacyPolicy() {
  const p = usePage("privacy");
  return <ContentPage eyebrow={p.eyebrow} title={p.title} intro={p.intro} path="/privacy-policy" sections={p.sections} />;
}

export function Terms() {
  const p = usePage("terms");
  return <ContentPage eyebrow={p.eyebrow} title={p.title} intro={p.intro} path="/terms" sections={p.sections} />;
}

export function MedicalDisclaimer() {
  const p = usePage("medical");
  return <ContentPage eyebrow={p.eyebrow} title={p.title} intro={p.intro} path="/medical-disclaimer" sections={p.sections} />;
}

export function ImageConsentPolicy() {
  const p = usePage("imageConsent");
  return <ContentPage eyebrow={p.eyebrow} title={p.title} intro={p.intro} path="/image-consent-policy" sections={p.sections} />;
}

export function CookiePolicy() {
  const p = usePage("cookie");
  return <ContentPage eyebrow={p.eyebrow} title={p.title} intro={p.intro} path="/cookie-policy" sections={p.sections} />;
}
